/* eslint-disable no-undef */
import previewStore from "@/stores/previewStore";

const minSpeed = 0.5;
const maxSpeed = 4.0;
import ConfigStore from "@/stores/mixedConfig";
const MaterialType = {
  VIDEO: 1,
  AUDIO: 2,
  IMAGE: 3,
};

function generateCombinations(
  arr,
  combinationLength,
  usedElements,
  uniqueElements = false,
) {
  const results = [];

  function backtrack(start, currentCombination) {
    // 如果当前组合的长度等于指定长度，则调用验证函数
    if (currentCombination.length === combinationLength) {
      if (!uniqueElements || isUnique(currentCombination, usedElements)) {
        results.push([...currentCombination]);
        if (uniqueElements) {
          currentCombination.forEach((item) => usedElements.add(item.id));
        }
      }
      return;
    }

    // 遍历数组并递归生成组合
    for (let i = start; i < arr.length; i++) {
      currentCombination.push(arr[i]);
      backtrack(i + 1, currentCombination);
      currentCombination.pop(); // 回溯
    }
  }

  backtrack(0, []);
  return results;
}

const isUnique = (comb, usedElements) => {
  const result = comb.every((item) => !usedElements.has(item.id));
  return result;
};

// 这里验证组合
const isValid = (comb, captionDurations, speed = "origin") => {
  const segsDuration = getMaterialsDuration(comb) / 1000;
  for (const capDuration of captionDurations) {
    if (speed === "follow_audio") {
      const speedFactor = Number(segsDuration) / Number(capDuration);
      if (speedFactor >= minSpeed && speedFactor <= maxSpeed) {
        // 这里是判断变速是否满足条件
        return true;
      }
    } else {
      if (segsDuration >= capDuration) {
        return true;
      }
    }
  }
  return false;
};

// 预估台词时长
const estimateDuration = (lines, wordsPerTime = 1 / 3, isSSML = false, isEn = false) => {
  if (lines.length === 0) {
    return 0;
  }
  if (isSSML) {
    const duration = lines.reduce(
      (acc, cur) => acc + estimateSSMLDuration(cur, wordsPerTime, isEn),
      0,
    );
    return duration + wordsPerTime * lines.length;
  }
  const combinedText = lines.join(",");
  const totalCharacters = combinedText.length;
  return totalCharacters * wordsPerTime;
};

function estimateSSMLDuration(ssml, wordsPerTime = 1 / 3, isEn = false) {
  // 匹配所有 <break> 标签并提取时间
  const breakRegex = /<break time=['"](.+?)['"]\/>/g;
  let breakMatch;
  let totalBreakTime = 0;

  // 遍历 <break> 标签并累加休止时间
  while ((breakMatch = breakRegex.exec(ssml)) !== null) {
    const breakTimeStr = breakMatch[1];
    // 将时间字符串转为数字
    const breakTime = parseFloat(breakTimeStr);
    totalBreakTime += breakTime;
  }

  // 去除所有 <break> 和其他标签，计算纯文本字数
  const textOnly = ssml.replace(/<[^>]+>/g, "");
  let textLength = textOnly.length;
  // 英文文本，按音节计算长度
  if (isEn) {
    textLength = countSyllables(textOnly)
  }

  // 按每3个字1秒计算文本时长
  const textDuration = textLength * wordsPerTime;

  // 总时长
  const totalDuration = textDuration + totalBreakTime;

  return Number(totalDuration.toFixed(2)); // 返回秒数，保留两位小数
}


const getMaterialsDuration = (materials) => {
  return materials.reduce((acc, cur) => acc + cur.duration, 0);
};
// 英文文本音节计数
function countSyllables(text) {
  // 将文本转换为小写，并去掉非字母字符
  text = text.toLowerCase().replace(/[^a-z\s]/g, "");

  // 按空格分割单词
  const words = text.split(/\s+/);

  // 定义元音集合
  const vowels = "aeiouy";

  // 音节计数
  let totalSyllables = 0;

  words.forEach(word => {
    let syllables = 0;
    let prevCharWasVowel = false;

    // 遍历每个字母
    for (let i = 0; i < word.length; i++) {
      const char = word[i];
      const isVowel = vowels.includes(char);

      // 如果当前是元音，且前一个字符不是元音，则计为一个音节
      if (isVowel && !prevCharWasVowel) {
        syllables++;
      }
      prevCharWasVowel = isVowel;

      // 特殊规则：单词结尾的静音 "e"
      if (i === word.length - 1 && char === 'e' && syllables > 1) {
        syllables--;
      }
    }

    // 确保至少有一个音节
    if (syllables === 0) {
      syllables = 1;
    }

    totalSyllables += syllables;
  });

  return totalSyllables;
}
// function pickGlobalCaptions(data) {
//     let fixedDuration = 0;
//     let originDuration = 0;

//     for (let i = 0; i < data.scenes.length; i++) {
//         const scene = data.scenes[i];
//         const md = getMaterialsDuration(scene.materials);
//         if (scene.setting.speed === 'follow_audio') {
//             fixedDuration += md;
//         } else {
//             originDuration += md;
//         }
//     }
//     var captions = [];
//     for (let i = 0; i < data.global_settings.captions.length; i++) {
//         const caption = data.global_settings.captions[i]; // 全局
//         const duration = estimateDuration(caption.content); // 估计台词时间
//         const speedFactor = Math.round((fixedDuration / (duration - originDuration)) * 100) / 100;
//         console.log(caption, duration, fixedDuration, originDuration)
//         console.log("speedFactor", speedFactor)
//         if (speedFactor >= minSpeed && speedFactor <= maxSpeed) {
//             captions.push(caption);
//         }
//     }
//     console.log(captions)
//     return captions;
// }

// 计算全局下的视频合成预计数量
function combGlobalMaterials(data) {
  const sceneCombCount = [];
  for (let i = 0; i < data.scenes.length; i++) {
    const scene = data.scenes[i];
    const combCount =
      scene.setting.clip_rule === "single_video"
        ? scene.materials.length
        : 2 ** scene.materials.length - 1;
    sceneCombCount.push(combCount);
  }
  return sceneCombCount.reduce((acc, cur) => acc * cur, 1);
}

// 生成各分镜组合
function combSenceMaterials(data) {
  const errors = [];
  let maxCount, minDuration, maxDuration;
  if (!data.global_settings.enabled) {
    const combinations = [];
    for (let i = 0; i < data.scenes.length; i++) {
      const result = [];
      const scene = data.scenes[i];
      const durationFix =
        (data.transition[String(i)]?.effects?.length > 0
          ? data.transition[String(i)]?.duration || 500
          : 0) / 1000; // 如果有转场需要增加0.5秒时长
      const durations = scene.caption.map(
        (cap) =>
          estimateDuration(
            cap.content.map(
              (str) =>
                str
                  .replace(/>\s+</g, "><") // 移除标签之间的空白
                  .replace(/\s{2,}/g, " ") // 将多个空白字符替换为一个空格
                  .replace(/<speak>\s+/g, "<speak>") // 移除 <speak> 标签后多余的空白
                  .replace(/\s+<\/speak>/g, "</speak>") // 移除 </speak> 标签前多余的空白
                  .trim(), // 去除字符串首尾的空白
            ) || [],
            (cap.voice_setting?.default_speed_rate || 20) / 100,
            true,
            cap?.voice_setting?.lang == 'en'
          ) + durationFix,
      ); // 估计台词时间
      const combinationLength =
        scene.setting.clip_rule === "single_video" ? 1 : scene.materials.length; // 单镜头时使用单个素材，多镜头时使用素材数组
      const usedElements = new Set(); // 使用过的元素缓存
      const uniqueElements = scene.setting.clip_rule === "single_times"; // 是否只使用一次（单次魔剪)
      for (let j = 0; j < combinationLength; j++) {
        const combinations = generateCombinations(
          scene.materials,
          j + 1,
          usedElements,
          uniqueElements,
        );
        for (const comb of combinations) {
          // 全局配置下不判断分镜
          if (
            data.global_settings.enabled ||
            isValid(comb, durations, scene.setting.speed)
          ) {
            // console.log("Item:", comb.map(v => v.id));
            result.push(comb);
          }
        }
      }
      if (result.length === 0)
        errors.push({ scene: i, message: scene.setting.speed === "origin" ? "分镜素材时长不足" : "分镜素材不符合变速条件" });
      combinations.push(result);
    }
    maxCount = getCombinationMaxCount(combinations);
    const durationRange = getSceneCaptionDuration(data);
    minDuration = Math.max(durationRange.min - 1, 0);
    maxDuration = durationRange.max > 0 ? durationRange.max + 1 : 0;
  } else {
    maxCount = combGlobalMaterials(data);
    const durationRange = getGlobalCaptionDuration(data);
    minDuration = Math.max(durationRange.min - 1, 0);
    maxDuration = durationRange.max > 0 ? durationRange.max + 1 : 0;
  }

  return {
    maxCount,
    minDuration,
    maxDuration,
    errors,
  };
}
// 预估分镜模式的合成数量
function getCombinationMaxCount(combinations) {
  return combinations.map((v) => v.length).reduce((acc, cur) => acc * cur, 1);
}

function getGlobalCaptionDuration(data) {
  const captionGroupDuration = data.global_settings.captions.map((cap) =>
    estimateDuration(
      cap.content,
      (cap.voice_setting?.default_speed_rate || 20) / 100,
      true,
      cap.voice_setting?.lang == 'en'
    ),
  );
  return {
    min: Math.min(...captionGroupDuration),
    max: Math.max(...captionGroupDuration),
  };
}

// 预估时长，返回最短到最长的秒数
function getSceneCaptionDuration(data) {
  let captionMaxDuration = 0,
    captionMinDuration = 0;
  for (let i = 0; i < data.scenes.length; i++) {
    const scene = data.scenes[i];
    // 分镜台词组的预估时长
    const captionGroupDuration = scene.caption.map((cap) =>
      estimateDuration(
        cap.content,
        (cap.voice_setting?.default_speed_rate || 20) / 100,
        true,
        cap.voice_setting?.lang == 'en'
      ),
    );
    captionMaxDuration += Math.max(...captionGroupDuration);
    captionMinDuration += Math.min(...captionGroupDuration);
  }
  return { min: captionMinDuration, max: captionMaxDuration };
}

// 根据一个视频素材，台词组，以及多行标题，生成一个预览时间轴
function combTimeline(material, caption, title) {
  console.log(previewStore.getBackground(), 'background')
  if (material?.type === MaterialType.AUDIO) {
    throw new Error("音频素材无法生成时间轴");
  }
  // 初始化视频
  const videoTrack = {
    Id: Date.now() + parseInt(Math.random() * 10000),
    Type: "Video",
    VideoTrackClips: [],
  };

  if (material) {
    videoTrack.VideoTrackClips.push(materialToClip(material));
  }
  if (previewStore.getBackground()?.image_url) {
    videoTrack.VideoTrackClips.push({
      MediaURL: previewStore.getBackground().image_url,
      Type: "Image",
      Width: 1,
      Height: 1,
      AdaptMode: "Cover",
      Duration: 2.084,
      TimelineIn: 0,
      TimelineOut: 2.084,
      Opacity: 1
    });
  }
  const subtitleTrack = {
    Id: Date.now() + parseInt(Math.random() * 10000),
    Type: "Subtitle",
    VideoTrackClips: [],
  };
  if (caption) {
    subtitleTrack.VideoTrackClips.push(
      captionToClip(caption, 0, material?.duration || 1),
    );
  }
  if (title) {
    subtitleTrack.VideoTrackClips.push(
      ...titleToClip(title, 0, material?.duration || 1),
    );
  }
  const decorationTrack = {
    Id: Date.now() + parseInt(Math.random() * 10000),
    Type: "Image",
    VideoTrackClips: [],
  };

  const transformArray = (decoration) => {
    return decoration.map((item, index) => ({
      ...(item.material || {}), // 如果 material 不存在，使用空对象
      ...(item.settings || {}), // 如果 settings 不存在，使用空对象
      id: item.id,
      x: item.settings?.x || 0,
      y: item.settings?.y || 0,
    }));
  };

  if (ConfigStore.global_settings.decorations && ConfigStore.global_settings.decorations.length > 0) {
    transformArray(ConfigStore.global_settings.decorations).forEach((item) => {
      decorationTrack.VideoTrackClips.push(
        decorationToClip(item)
      )
    });
  }
  return {
    VideoTracks: [videoTrack, decorationTrack, subtitleTrack],
  };
}

function getSubtitleEffects(backgroundColor, fontSize) {
  if (backgroundColor === "" || backgroundColor === 'transparent') return [];
  const bord = fontSize / 6;
  return [{
    "Type": "Box",
    "Color": backgroundColor,
    "Bord": bord,
    "Radius": 0,
  }]
}
function ToCoverAlignment(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
function captionToClip(caption, timelineIn = 0, timelineOut = 1.0) {
  const fontSize = caption.text_setting.font_size || 40;
  const effect = caption.text_setting.effect.advanced
    ? getEffectParam(fontSize)
    : {};
  const ssml = caption.content.length > 0 ? caption.content[0] : "";
  const subtitleEffects = getSubtitleEffects(caption.text_setting.background_color || "", fontSize);

  return {
    Id: caption.id,
    Type: "Text",
    X: caption.text_setting.x,
    Y: caption.text_setting.y,
    Content: ssml.replace(/<[^>]+>/g, ""),
    Alignment: ToCoverAlignment(caption.text_setting.alignment),
    FontSize: fontSize,
    FontColor: caption.text_setting.color || "#ffffff",
    FontColorOpacity: 1,
    EffectColorStyle: caption.text_setting.effect.effect_color_style || "",
    Outline: effect.outline || 0,
    OutlineColour: caption.text_setting.effect.outline_colour || "",
    Shadow: effect.shadow || 0,
    BackColour: caption.text_setting.effect.back_colour || "",
    Font: caption.text_setting.font || "Alibaba PuHuiTi",
    FontUrl: caption.text_setting.font_url || "",
    FontFace: {
      Bold: caption.text_setting.bold || false,
      Italic: caption.text_setting.italic || false,
      Underline: caption.text_setting.underline || false,
    },
    TimelineIn: timelineIn / 1000.0,
    TimelineOut: timelineOut / 1000.0,
    Spacing: caption.text_setting.spacing || 0,
    LineSpacing: caption.text_setting.line_spacing || 0,
    Angle: caption.text_setting.angle || 0,
    SubtitleEffects: subtitleEffects,
  };
}

function titleToClip(title, timelineIn = 0, timelineOut = 1.0) {
  return title.content.map((item) =>
    titleItemToClip(item, timelineIn, timelineOut),
  );
}

function titleItemToClip(item, timelineIn = 0, timelineOut = 1.0) {
  const fontSize = item.text_setting.font_size || 40;
  const effect = item.text_setting.effect.advanced
    ? getEffectParam(fontSize)
    : {};
  const subtitleEffects = getSubtitleEffects(item.text_setting.background_color || "", fontSize);
  return {
    Id: item.id,
    Type: "Text",
    X: item.text_setting.x,
    Y: item.text_setting.y,
    Content: item.text,
    Alignment: ToCoverAlignment(item.text_setting.alignment),
    FontSize: fontSize,
    FontColor: item.text_setting.color || "#ffffff",
    // FontColorOpacity: 1,
    EffectColorStyle: item.text_setting.effect.effect_color_style || "",
    Outline: effect.outline || 0,
    OutlineColour: item.text_setting.effect.outline_colour || "",
    Shadow: effect.shadow || 0,
    BackColour: item.text_setting.effect.back_colour || "",
    Font: item.text_setting.font || "Alibaba PuHuiT",
    FontUrl: item.text_setting.font_url || "",
    FontFace: {
      Bold: item.text_setting.bold || false,
      Italic: item.text_setting.italic || false,
      Underline: item.text_setting.underline || false,
    },
    TimelineIn: timelineIn / 1000.0,
    TimelineOut: timelineOut / 1000.0,
    Spacing: item.text_setting.spacing || 0,
    LineSpacing: item.text_setting.line_spacing || 0,
    Angle: item.text_setting.angle || 0,
    SubtitleEffects: subtitleEffects,
  };
}

function getEffectParam(fontSize, advanced = false) {
  if (!advanced) {
    return { outline: 0, shadow: 0 };
  }
  const preset = {
    fontWidth: 50,
    fontHeight: 50,
    strokeWidth: 4,
    shadowDistance: 4,
  };
  const outline = Math.round(
    ((preset.strokeWidth || 0) / (preset.fontWidth || 1)) * fontSize,
  );
  const shadow = Math.round(
    ((preset.shadowDistance || 0) / (preset.fontWidth || 1)) * fontSize,
  );

  return { outline, shadow };
}

function materialToClip(material, timelineIn = 0) {
  let type = "Video";
  let duration = 0;
  switch (material.type) {
    case MaterialType.VIDEO:
      type = "Video";
      break;
    case MaterialType.IMAGE:
      type = "Image";
      duration = material.duration;
      break;
    default:
      break;
  }
  let Effects = []
  if (ConfigStore.global_settings.background.color) {
    Effects.push({
      Type: "Background",
      SubType: "Color",
      Color: ConfigStore.global_settings.background.color
    })
  }
  if (ConfigStore.global_settings.background.blur.radius > 0) {
    Effects.push({
      Type: "Background",
      SubType: "Blur",
      Radius: ConfigStore.global_settings.background.blur.radius/100
    })
  }
  return {
    Id: material.id,
    Type: type,
    MediaId: material.media_id || "",
    MediaURL: material.url || "",
    X: material.x || 0,
    Y: material.y || 0,
    // AdaptMode: "Fill",
    In: material.start / 1000.0,
    Out: (material.start + material.duration) / 1000.0,
    TimelineIn: timelineIn / 1000.0,
    TimelineOut: (timelineIn + material.duration / (material.speed || 1)) / 1000.0,
    Duration: duration / 1000.0,
    Speed: material.speed,
    Effects: type === 'Video' && (ConfigStore.global_settings.background.blur.radius || ConfigStore.global_settings.background.color) ? Effects : [],
  };
}
function decorationToClip(material, timelineIn = 0, timelineOut = 1) {
  let duration = 0;
  return {
    Id: material?.id,
    Type: 'Image',
    MediaId: material.media_id || "",
    MediaURL: material.url || "",
    X: material.x || 0,
    Y: material.y || 0,
    AdaptMode: "Fill",
    Width: material?.width,
    Height: material?.height,
    In: 1,
    Out: 1,
    TimelineIn: timelineIn / 1000.0,
    TimelineOut: timelineOut / 1000.0,
    Duration: duration / 1000.0,
    Speed: material?.speed || 1,
  };
}

// 以下是示例用法

// const data = `{"scenes":[{"name":"视频组","setting":{"material_mute":true,"disabled":false,"speed":"origin","clip_rule":"auto"},"materials":[{"media_id":"02d82af094d971ef8328f6f7c77a6302","type":1,"width":1080,"height":1920,"start":0,"duration":2433,"id":93,"is_cropped":false,"speed":1}],"caption":[{"id":"9391a37f-3654-4ca5-a270-0fb38eb5b64a","content":["<speak>帮我看一下女朋友1</speak>"],"_content_json":[{"type":"listItem","content":[{"type":"paragraph","content":[{"type":"text","text":"帮我看一下女朋友1"}]}]}],"_preview":"\n\n\n\n帮我看一下女朋友1","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#000000","background_color":"#000000","bold":false,"italic":false,"alignment":"left","effect":{},"x":0.5,"y":0.8,"angle":0},"voice_setting":{"ssml":true,"speaker_id":"BV001_streaming","speed_ratio":1,"volume_ratio":0.7,"pitch_ratio":1,"emotion":"","is_global":false}},{"id":"f5ff4441-e4cf-4b50-81a6-c948ed33c561","content":[],"_content_json":null,"_preview":"","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#000000","background_color":"#000000","bold":false,"italic":false,"alignment":"left","effect":{},"x":0.5,"y":0.8,"angle":0},"voice_setting":{"ssml":true,"speaker_id":"BV001_streaming","speed_ratio":1,"volume_ratio":0.7,"pitch_ratio":1,"emotion":"","is_global":false}}],"title":{"content":[{"text":"这是分镜一的标题","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#ff6600","background_color":"#eeeeee","bold":false,"italic":false,"alignment":"center","effect":{},"x":0.5,"y":0.1,"angle":0,"start":0}}]}},{"name":"视频组","setting":{"material_mute":true,"disabled":false,"speed":"origin","clip_rule":"auto"},"materials":[{"media_id":"03576d1094d971ef83c7f6f7c6696302","type":1,"width":1080,"height":1920,"start":0,"duration":2466,"id":94,"is_cropped":false,"speed":1}],"caption":[{"id":"9391a37f-3654-4ca5-a270-0fb38eb5b64a","content":["<speaker>站在风中凌乱</speaker>"],"_content_json":[{"type":"listItem","content":[{"type":"paragraph","content":[{"type":"text","text":"站在风中凌乱"}]}]}],"_preview":"\n\n\n\n站在风中凌乱","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#000000","background_color":"#000000","bold":false,"italic":false,"alignment":"left","effect":{},"x":0.5,"y":0.8,"angle":0},"voice_setting":{"ssml":true,"speaker_id":"BV001_streaming","speed_ratio":1,"volume_ratio":0.7,"pitch_ratio":1,"emotion":"","is_global":false}}],"title":{"content":[{"text":"风中有朵雨做的云","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#ff6600","background_color":"#eeeeee","bold":false,"italic":false,"alignment":"center","effect":{},"x":0.5,"y":0.1,"angle":0,"start":0}}]}}],"transition":{"0":{"start_sence":0,"effects":[],"is_global":false},"1":{"start_sence":1,"effects":[],"is_global":false}},"global_settings":{"enabled":false,"titles":[{"content":[{"text":"这是分镜一的标题","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#ff6600","background_color":"#eeeeee","bold":false,"italic":false,"alignment":"center","effect":{},"x":0.5,"y":0.1,"angle":0,"start":0}}]},{"content":[{"text":"风中有朵雨做的云","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#ff6600","background_color":"#eeeeee","bold":false,"italic":false,"alignment":"center","effect":{},"x":0.5,"y":0.1,"angle":0,"start":0}}]}],"captions":[{"id":"台词组1","content":[],"_content_json":null,"_preview":"","text_setting":{"font":"Microsoft YaHei","font_size":30,"color":"#000000","background_color":"#000000","bold":false,"italic":false,"alignment":"left","effect":{},"x":0.5,"y":0.8,"angle":0},"voice_setting":{"speaker_id":"","speed_ratio":1,"volume_ratio":0.7,"pitch_ratio":1,"emotion":"","ssml":true}}],"transition":{"effects":[]},"cover":{"images":[]},"background":{"audio":[],"color":"#FBD96D","images":[{"id":230,"name":"圣诞19","cover_url":"/background/14a47a14-73aa-4ed4-98dc-fff80e96c8fd_cover.png","file_url":"/background/14a47a14-73aa-4ed4-98dc-fff80e96c8fd.png","created_at":1726645160,"updated_at":1726645160,"url":"https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/background/14a47a14-73aa-4ed4-98dc-fff80e96c8fd_cover.png"},{"id":233,"name":"手绘29","cover_url":"/background/8b44714d-7c44-4366-9e4c-2a95bdca1f99_cover.png","file_url":"/background/8b44714d-7c44-4366-9e4c-2a95bdca1f99.png","created_at":1726645160,"updated_at":1726645160,"url":"https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/background/8b44714d-7c44-4366-9e4c-2a95bdca1f99_cover.png"},{"id":229,"name":"手绘28","cover_url":"/background/f1f30fe8-71f6-455f-98b9-8b89df86c1ca_cover.png","file_url":"/background/f1f30fe8-71f6-455f-98b9-8b89df86c1ca.png","created_at":1726645160,"updated_at":1726645160,"url":"https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/background/f1f30fe8-71f6-455f-98b9-8b89df86c1ca_cover.png"},{"id":231,"name":"圣诞18","cover_url":"/background/92e2c5d2-92ae-4bec-ae5c-4fc3e1007653_cover.png","file_url":"/background/92e2c5d2-92ae-4bec-ae5c-4fc3e1007653.png","created_at":1726645160,"updated_at":1726645160,"url":"https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/background/92e2c5d2-92ae-4bec-ae5c-4fc3e1007653_cover.png"},{"id":232,"name":"圣诞17","cover_url":"/background/7db8ede6-07be-48cc-9827-bcc7fde62b64_cover.png","file_url":"/background/7db8ede6-07be-48cc-9827-bcc7fde62b64.png","created_at":1726645160,"updated_at":1726645160,"url":"https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/background/7db8ede6-07be-48cc-9827-bcc7fde62b64_cover.png"}]}}}`
// const sessionJSON = JSON.parse(data.replace(/[\u0000-\u001F\u007F]/g, ""));

// combSenceMaterials(sessionJSON);

// console.log(getSceneCaptionDuration(sessionJSON))

// const timeline = combTimeline(sessionJSON.scenes[0].materials[0], sessionJSON.scenes[0].caption[0], sessionJSON.scenes[0].title);
// console.log("timeline:", JSON.stringify(timeline));

export { estimateDuration, combSenceMaterials, combTimeline, getEffectParam };
